const API_ENDPOINTS = {
  WEATHER_API_KEY: "6995db48b84aa7cac68e95540c1bc36e",
  DEFAULT_LOC: "https://ipapi.co/json/",
  TARGET_LOC: "https://api.openweathermap.org/geo/1.0/direct",
  CURRENT_WEATHER: "https://api.openweathermap.org/data/2.5/weather",
  PERIODIC_WEATHER: "https://api.openweathermap.org/data/2.5/forecast",
};

export default API_ENDPOINTS;
